<template>
  <div id="aside" class="sidebar">
    <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" :collapse-transition="false" unique-opened router>
      <template v-for="menu in menus">
        <template v-if="menu.children">
          <el-submenu :index="menu.resourcename" :key="menu.resourcename">
            <template slot="title">
              <i :class="getMenuIcon(menu.icon)"></i>
              <span>&nbsp;{{menu.resourceinfo}}</span>
            </template>
            <el-menu-item
              v-for="(child, childIndex) in menu.children"
              :key="childIndex"
              :index="child.resourcename"
            >
              {{child.resourceinfo}}
              <!--<router-link :to="children.path">{{children.meta.title}}</router-link>-->
            </el-menu-item>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="menu.resourcename" :key="menu.resourcename">
            <i :class="getMenuIcon(menu.icon)"></i>
            <span>&nbsp;{{menu.resourceinfo}}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import bus from "../../../common/js/bus";
import { mapMutations } from "vuex";
export default {
  name: "AsideDom",
  data() {
    return {
      collapse: false,
      isCollapse: false,
      isUniqueOpened: true,
      isRouter: true,
      menus: [],
      allMenus: this.CONSTANT.menus
    };
  },
  mounted() {
    /**采用固定2位前缀命名的path */
    /**
    var index = this.findIndex(this.$route.path, "/", "2");
    this.initMenu(index<=0 ? this.$route.path : this.$route.path.substring(0, index));
     */
    /**采用路由方式加载菜单的path */
    var matched = this.$route.matched;
    var path = this.$route.path;
    if(this.$route.matched.length > 2){
      path = this.$route.matched[1].path;
    }
    this.initMenu(path);
  },
  methods: {
    //初始化菜单
    initMenu(val) {
      let vm = this;
      if(val.indexOf("/home") != 0){
        if(val == "XCPS"){
          vm.menus = vm.allMenus[0].children;
        }else{
          for(var i in vm.allMenus){
            if(vm.allMenus[i].resourcename == val){
                vm.menus = vm.allMenus[i].children;
                let path = vm.menus[0].resourcename;
                if(vm.menus.length > 0){
                  if(vm.menus[0].children!=null && vm.menus[0].children.length>0){
                    path = vm.menus[0].children[0].resourcename;
                  }
                }
                vm.$router.replace({ path : path });
                break;
            }else{
              if(vm.allMenus[i].children != null && vm.allMenus[i].children.length > 0){
                for(var j in vm.allMenus[i].children){
                  if(vm.allMenus[i].children[j].resourcename == val){
                    vm.menus = vm.allMenus[i].children;
                    break;
                  }else{
                    if(vm.allMenus[i].children[j].children != null && vm.allMenus[i].children[j].children.length > 0){
                      for(var k in vm.allMenus[i].children[j].children){
                        if(vm.allMenus[i].children[j].children[k].resourcename == val){
                          vm.menus = vm.allMenus[i].children;
                          break;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    getMenuIcon(value) {
      return "iconfont " + value;
    },
    //查找字符串第num次出现的位置
    findIndex(str, cha, num){
      var x = str.indexOf(cha);
      for(var i = 0; i < num; i++){
          x = str.indexOf(cha, x+1);
      }
      return x;
      }
  },
  watch:{
    $route(to, from){
      var toPath = to.path;
      var fromPath = from.path;
      if(toPath.split("/")[1] != fromPath.split("/")[1]){
        if(this.$route.length > 2){
          this.initMenu(this.$route.matched[1].path);
        }else{
          this.initMenu(to.path);
        }
      }else{
        if(toPath.split("/").length == 2){
          let path = this.menus[0].resourcename;
          if(this.menus.length > 0){
            if(this.menus[0].children!=null && this.menus[0].children.length>0){
              path = this.menus[0].children[0].resourcename;
            }
          }
          this.$router.replace({ path : path });
        }
      }
      //清除store中listPagePars add by li.xue 2020/12/15
      let toMatched = to.matched[1].path;
      let fromMatched = from.matched[1].path;
      if((toMatched.endsWith('/')?toMatched.substr(0,toMatched.length-1):toMatched) 
        != (fromMatched.endsWith('/')?fromMatched.substr(0,fromMatched.length-1):fromMatched)){
        if(Object.keys(this.$store.state.listPagePars).length > 0){
          this.$store.commit('RESET_LIST_PAGE_PERS');
        }
      }
    }
  },
  computed: {
    onRoutes() {
      //var subMenus = this.$parent.subMenus;
      var subMenus = this.menus;
      var routePath = this.$route.path;
      if(this.$route.matched.length > 3){
        routePath = this.$route.matched[2].path;
      }else if(this.$route.matched.length == 3 && !this.$route.matched[2].path.endsWith('/')){
        routePath = this.$route.matched[1].path;
      }
      if(routePath.endsWith('/')){
        routePath = routePath.substr(0, routePath.length-1);
      }
      for(var i in subMenus){
        if(routePath == subMenus[i].resourcename){
          this.subMenus = subMenus[i].children;
        }else{
          if(subMenus[i].children != null){
            for(var j in subMenus[i].children){
              if(routePath == subMenus[i].children[j].resourcename){
                this.subMenus = subMenus[i].children;
              }
            }
          }
        }
        return routePath;
      }

      /**页面为子页面时，选中其父菜单 by li.xue 2019/3/13
        var routeMatched = [];
        var defaultActive = '';
        routeMatched = this.$route.matched
        for (var i in routeMatched) {
          if (routeMatched[i].meta.title) {
            defaultActive = routeMatched[i].path;
            break;
          }
        }
        return defaultActive;
        */
    }
  },
  created() {
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on("collapse", msg => {
      this.collapse = msg;
    });
  }
};
</script>

<style lang="scss">
@import "../../../common/scss/mixin.scss";
#aside{

}
</style>



// WEBPACK FOOTER //
// src/views/common/layout/AsideDom.vue